import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useClient } from '../../client-api';
import { getExternalAssetsSettings, type PanelSettingsDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useProjectionExternalAssetSettings(): UseQueryResult<PanelSettingsDto, AxiosError> {
    const { data: client } = useClient();
    const queryKey = useMemo(() => queryKeys.saeExternalAssetSettings(client?.partnerUuid), [client?.partnerUuid]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getExternalAssetsSettings({ query: { clientId: client!.id }, signal }).then((result) => result.data),
        enabled: !!client,
    });
}
